export default "__VITE_ASSET__bd24e7d7__"